//load scripts
jQuery( document ).ready(function($) {

    if( $('.izjava').length ) {
        $('.izjava').find('.wpcf7-list-item-label').html('<a href="/pravna-obvestila/">Izjava zasebnosti</a>')
    }

    $('.odpri-vse').on('click', function (e) {
        $( this ).remove();
        e.preventDefault();
        $('.za-odpret').show();
    });

    $('.piskotki').on('click', function (e) {
        e.preventDefault();
        $( this ).remove();
        setCookie('cookieAccept', 'ok', '365');
    });

    $('.logo-input-custom').on('click', function (e) {
        if( e.target.className === 'logo-input-custom' ) {
            $('.podpisi-listino-form input[type="file"]').click();
        } else if( e.target.className === 'remove-logo' ) {
            $('.logo-input-custom').html( "Logotip podjetja" );

            var logoInput = $('[name="logotip"]');
            logoInput.wrap('<form>').closest('form').get(0).reset();
            logoInput.unwrap();
        }
    });

    $('[name="logotip"]').on('change', function() {
        if( this.files.length === 0 )
            $('.logo-input-custom').html( "Logotip podjetja" );
    });

    //on file select or change
    $('.podpisi-listino-form input[type="file"]').on('change', function() {

        if( this.files[0].name ) {
            $('.logo-input-custom').html( this.files[0].name + "<span class='remove-logo'>x</span>" );
        } else {
            $('.logo-input-custom').text( "Logotip podjetja" );
        }

    });

    $('.gradivo-link a').on('click', function (e) {

        window.clickedLink = this;

        if( getCookie( 'canDownload' ) != 'true' ) {
            e.preventDefault();
            $('.subscribe-modal-gradiva').show();
        }

    });

    $('a.novice').on('click', function (e) {
        e.preventDefault();
        $('.subscribe-modal-subscribe').show();
    });

    $('.close-modal').on('click', function () {
        $('.modal-wrapper').hide();
    });

    $('#naroci-gradivo-form').on('submit', function (e) {

        e.preventDefault();
        var form = $( this );
        var name = form.find('.ime').val();
        var email = form.find('.email').val();
        var button = form.find('.subscribe-button');
        var errorMsg = form.siblings('.error-msg');
        var buttonVal = button.text();
        button.text("Pošiljam...");
        errorMsg.text();

        $.ajax({
            url: ajaxObject.ajaxurl,
            data: {
                name: name,
                email: email,
                action: 'lr_subscribe_mailchimp'
            },
            type: 'POST',
            success: function(data){
                if( data.response === 200 ) {
                    setCookie('canDownload', 'true', '365');
                    $( ".gradivo-link" ).each(function( index, el ) {
                        $( el ).find('.prenesi-link').attr( "href", $( el ).data('fileurl') );
                    });
                    $('#naroci-gradivo-form').html('<p>Uspešno ste ste oddali email. Sedaj si lahko ogledate vsa naša gradiva.</p>');
                } else {
                    button.text( buttonVal );
                    errorMsg.text('Prišlo je do napake.');
                }
            },
            error: function() {
                button.text( buttonVal );
                errorMsg.text('Prišlo je do napake.');
            }
        });

    })

    $('#subscribe-form').on('submit', function (e) {

        e.preventDefault();
        var form = $( this );
        var name = form.find('.ime').val();
        var email = form.find('.email').val();
        var button = form.find('.subscribe-button');
        var errorMsg = form.siblings('.error-msg');
        var buttonVal = button.text();
        button.text("Pošiljam...");
        errorMsg.text();

        $.ajax({
            url: ajaxObject.ajaxurl,
            data: {
                name: name,
                email: email,
                action: 'lr_subscribe_mailchimp'
            },
            type: 'POST',
            success: function(data){
                if( data.response === 200 ) {
                    form.text('Uspešno ste se naročili na novice.');
                } else {
                    button.text( buttonVal );
                    errorMsg.text('Prišlo je do napake.');
                }
            },
            error: function() {
                button.text( buttonVal );
                errorMsg.text('Prišlo je do napake.');
            }
        });

    });

    $('a.popup').on('click', function (e) {
        e.preventDefault();
        var copy = $( this ).data('copy');
        $('.empty-modal').show();
        $('.empty-modal .copy').html( "<h2>" + $( this ).text() + "</h2>" + "<p>" + copy + "</p>");
    });

    $( ".ambasadorji .flip-box-wrap" ).each(function( index, el ) {
        $( el ).height( $(el).width() );
    });

    $( window ).resize(function() {
        $( ".ambasadorji .flip-box-wrap" ).each(function( index, el ) {
            $( el ).height( $(el).width() );
        });
    });

    $('.pokazi-vse-ambasadorje').on('click', function (e) {
        e.preventDefault();
        $( this ).closest('.vc_row').remove();
        $('.ambasadorji').removeClass('hidden');
        $( ".ambasadorji .flip-box-wrap" ).each(function( index, el ) {
            $( el ).height( $(el).width() );
        });
    });

    var wpcf7s = document.querySelectorAll('.wpcf7');
    for (var i = 0; i < wpcf7s.length; i++) {
        wpcf7s[i].addEventListener( 'wpcf7submit', function( event ) {
            var inputs = event.detail.inputs, email, imepodpisnika, issubscribed = false;
            for ( i in inputs ) {
                if( inputs[i].name === 'email' ) {
                    email = inputs[i].value;
                } else if( inputs[i].name === 'ime-podpisnika' ) {
                    imepodpisnika = inputs[i].value;
                } else if( inputs[i].name === 'novice-checkbox[]' ) {
                    issubscribed = true;
                }
            }
            if( issubscribed ) {

                $.ajax({
                    url: ajaxObject.ajaxurl,
                    data: {
                        name: imepodpisnika,
                        email: email,
                        action: 'lr_subscribe_mailchimp_main_form'
                    },
                    type: 'POST',
                    success: function(data){
                        console.log( data );
                    }
                });

            }
            $('.logo-input-custom').html( "Logotip podjetja" );
        }, false );
    }

});

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}